import React, { useState, useRef, useEffect, useMemo } from "react";
import { addData, deleteData, editData, getData } from "../../controllers/sports.controller";
import toast from 'react-hot-toast';
import {
    IconPlus,
} from "@tabler/icons-react";
import { RiListRadio, RiDeleteBin2Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import Button from "../../Components/Button";
import Page from "../../Components/Page";
import FlyerManagement from "./FlyerManagement";
import HeaderSection from "./HeaderSection";
import JobListings from "./JobListings";

const Career = () => {

    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [isOpen, setIsOpen] = useState(false);
    const [data, setData] = useState([]);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [image, setImage] = useState(null);

    const years = Array.from({ length: 201 }, (_, i) => 1900 + i); // 1900 to 2100


    const [formData, setFormData] = useState({
        year: new Date().getFullYear(),

        description: "",
        file: null,
        sport_activity: ""
    });



    const [toggles, setToggles] = useState([
        { label: 'Header Section', icon: <IconPlus />, isToggled: true },
        { label: 'Flyer Management', icon: <RiListRadio />, isToggled: false },
        { label: 'Careers', icon: <RiListRadio />, isToggled: false },
    ]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        setFormData({ ...formData, file: e.target.files[0] });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form Submitted: ", formData);

    };




    const fetchTableData = async () => {
        try {
            const res = await getData({});
            console.log('res => ', res);

            if (res.status === 200) {
                const apiData = res?.data?.data;


                const tableData = apiData?.map((d) => ({
                    id: d.id,
                    sport_activity: d.sport_activity,
                    description: d.description,
                    file: d.file
                }));


                setData(tableData);
            } else {
                console.error("Failed to fetch data:", res);
            }
        } catch (error) {
            console.error("Error fetching table data:", error);
        }
    };


    useEffect(() => {
        fetchTableData();
    }, []);


    // add
    const addBtn = async () => {
        try {
            const { sport_activity, description, file } = formData;

            if (!sport_activity || !description || !file) {
                toast.error("Please fill in all the required fields and upload a document.");
                return;
            }

            toast.loading("Submitting your data...");


            const res = await addData({
                sport_activity,
                description,
                file,

            });

            const message = res.data.message;
            toast.dismiss();

            if (res.status === 200) {
                toast.success(message);
                setFormData({
                    sport_activity: "",
                    description: "",
                    file: null,

                });

                fetchTableData()
            } else {
                toast.error(message || "Failed to add research data.");
            }
        } catch (error) {
            toast.dismiss();
            console.error("Error adding research data:", error);


            const message = error?.response?.data?.message || "Something went wrong!";
            toast.error(message);
        }
    };

    // edit
    const editReseachBtn = async () => {
        try {
            const { sport_activity, description, file, } = formData;

            if (!sport_activity || !description || !file) {
                toast.error("Please fill in all the required fields and upload a document.");
                return;
            }

            toast.loading("Submitting your data...");


            const res = await editData({
                id: selectedRowId,

                sport_activity,
                description,
                file: null,

            });

            const message = res.data.message;
            toast.dismiss();

            if (res.status === 200) {
                toast.success(message);
                setFormData({
                    sport_activity: "",
                    description: "",
                    file: null,

                });

                document.getElementById("modal-edit").close()
                fetchTableData()
            } else {
                toast.error(message || "Failed to add research data.");
            }
        } catch (error) {
            toast.dismiss();
            console.error("Error adding research data:", error);


            const message = error?.response?.data?.message || "Something went wrong!";
            toast.error(message);
        }
    };


    // delete
    const deleteStLifeBtn = async () => {
        try {
            if (selectedRowId) {
                toast.loading("Please wait...");
                const res = await deleteData({ id: selectedRowId })
                const message = res.data.message;
                toast.dismiss();
                if (res.status === 200) {
                    toast.success(message);
                    fetchTableData()
                    setSelectedRowId(null)
                    document.getElementById("modal-delete").close()
                } else {
                    toast.error(message);
                }
            }
        } catch (error) {
            console.error(error);
            const message = error?.response?.data?.error || "Something went wrong!";
            toast.dismiss();
            toast.error(message);
        }
    }


    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImage(URL.createObjectURL(file));
            setSelectedFile(file)
        } else setSelectedFile(null)

    };

    const handleRemoveImage = () => {
        setImage(null); // Reset the image state
    };


    const handleToggle = (index) => {
        setToggles((prevToggles) =>
            prevToggles.map((toggle, i) => ({ ...toggle, isToggled: i === index }))
        );
    };

    const toggeledIndex = useMemo(() => {
        return toggles.findIndex((d) => d.isToggled)
    }, [toggles])



   
    return (
        <Page className="px-8 py-6">
            <div className='flex text-xl gap-10 items-center'>
                <div className="text-[#100f13]">

                    <span className="text-[black] bg-white mt-6">  Career  </span>
                </div>
            </div>
            <div className="flex flex-wrap gap-4 mt-4">
                {toggles.map((toggle, index) => (
                    <div key={toggle.id} className="flex flex-col items-center">

                        <Button styles={'h-100'} outlined={!toggle.isToggled} onClick={() => handleToggle(index)}>
                            <span className="flex flex-row items-center justify-center w-[150px]">{toggle.icon} {toggle.label}</span>
                        </Button>

                    </div>

                ))}
            </div>

            <div className="w-full mx-auto mt-10 p-6 bg-white shadow-lg rounded-lg">
               

                {toggeledIndex === 0 ? (
                    <div>
                        <HeaderSection/>
                    </div>
                ) : toggeledIndex === 1 ? (
                    <div>
                        <FlyerManagement/>
                    </div>
                ) : toggeledIndex === 2 ? (
                    <div>
                        <JobListings/>
                    </div>
                ) :
                    <></>
                }




            </div>
            <dialog
                id="modal-edit"
                className="modal modal-bottom xl:modal-middle inset-0 z-50 rounded-lg w-[600px]"
            >
                <div className="p-6">
                    <h1 className="text-2xl font-bold mb-6">Edit Sport</h1>
                    <form onSubmit={(e) => e.preventDefault()}>

                        <div className="mb-4">
                            <label htmlFor="title" className="block text-gray-600 mb-2">
                                Sport Activity
                            </label>
                            <input
                                type="text"
                                id="sport_activity"
                                name="sport_activity"
                                value={formData.sport_activity}
                                onChange={handleChange}
                                className="block w-full border border-gray-300 rounded-lg px-3 py-2 shadow-sm"
                            />
                        </div>
                        <div className="grid grid-cols-2 gap-6">

                            <div className="mb-6">
                                <h1 className="block text-black font-medium mb-2 text-[18px]" htmlFor="welcomeMessage">
                                    Logo <b className="text-[#4B465C]">(Accept: .jpg, .png)</b>
                                </h1>
                                <div className="mt-2 flex flex-col items-center justify-center border-dashed border-2 border-gray-300 rounded-lg h-36">
                                    {image ? (

                                        <>
                                            <img src={image}
                                                alt="Uploaded Preview"
                                                className="h-28 w-auto object-contain" />
                                            <button
                                                onClick={handleRemoveImage}

                                            >
                                                Remove Image
                                            </button>
                                        </>
                                    ) : (
                                        <div className="text-gray-500">
                                            <div className="flex justify-center">
                                                <svg
                                                    xmlns="testing imgage"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    strokeWidth={1.5}
                                                    stroke="currentColor"
                                                    className="w-10 h-10"
                                                >
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                                                </svg>
                                            </div>
                                            <p>Drag and drop image here</p>
                                            {/* <p>or</p> */}
                                            <p className="text-sm text-center text-gray-400">
                        Any size of image, will automatically adjust to the frame 
                        </p>
                                            <div className='flex gap-10'>
                                                <label className="px-4 py-2 text-[#92288C] rounded-md cursor-pointer border-2 border-[#92288C] hover:bg-[#92288C] hover:text-white">
                                                    <input
                                                        type="file"
                                                        accept=".jpg, .png"
                                                        onChange={handleImageChange}
                                                        className="hidden"
                                                    />
                                                    Browse image
                                                </label>

                                            </div>
                                        </div>
                                    )}



                                </div>
                            </div>




                            <div className="mb-4 w-full text-left">
                                <div>
                                    <label className="block text-gray-600 font-medium mb-1"> Description</label>

                                    <textarea

                                        id="description"
                                        name="description"
                                        value={formData.description}
                                        onChange={handleChange}
                                        rows="4"

                                        className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:[#92288C]"
                                    />

                                </div>

                            </div>

                        </div>



                        <div className="flex justify-end space-x-4">
                            <button
                                type="button"
                                className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md"
                                onClick={() => {
                                    document.getElementById("modal-edit").close()
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                onClick={() => editReseachBtn()}
                                className="px-4 py-2 bg-[#92288C] text-white rounded-md hover:bg-[#7a2175] justify-end"
                            >
                                Update
                            </button>


                        </div>
                    </form>
                </div>
            </dialog>

            <dialog
                id="modal-delete"
                className="modal modal-bottom sm:modal-middle inset-0 z-50 rounded-lg"
            >

                <div className="relative bg-white rounded-lg shadow-lg p-6 max-w-lg w-full mx-auto z-10">
                    <div className="text-center">
                        <h2 className="text-xl font-bold text-gray-900">
                            Delete
                        </h2>
                        <p className="text-gray-500 font-bold">
                            Are you sure?
                        </p>
                    </div>


                    <div className="mt-4 flex justify-center space-x-4">
                        <button
                            onClick={() => {
                                setSelectedRowId(null)
                                document.getElementById("modal-delete").close()
                            }}
                            className="rounded-lg hover:bg-gray-200 transition active:scale-95 hover:shadow-lg px-6 py-3 bg-gray-200 text-gray-600"
                        >
                            No
                        </button>
                        <button
                            onClick={async () => { deleteStLifeBtn(); }}
                            className="rounded-lg transition active:scale-95 hover:shadow-lg px-6 py-3 bg-[#92288C] text-white"
                        >
                            Yes
                        </button>
                    </div>
                </div>
            </dialog>

        </Page>

    );
};

export default Career;









